import { render, staticRenderFns } from "./ProfileChangeDarkmode.vue?vue&type=template&id=270407ac&scoped=true"
import script from "./ProfileChangeDarkmode.vue?vue&type=script&lang=js"
export * from "./ProfileChangeDarkmode.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeDarkmode.vue?vue&type=style&index=0&id=270407ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270407ac",
  null
  
)

export default component.exports